import React from "react";
import usePrograms from "./usePrograms";
import ProgramDropdown from "./ProgramDropdown.jsx";
import ProgramList from "./ProgramList.jsx";

const ProgramFilter = ({properties}) => {
    const {
        filteredPrograms,
        categoryOneOptions,
        categoryTwoOptions,
        selectedCategoryOne,
        selectedCategoryTwo,
        setSelectedCategoryOne,
        setSelectedCategoryTwo,
    } = usePrograms(properties?.lang, properties?.defaultCategoryLabel);

    return (
        <div>
            <div className={"program-list__filters"}>

                <ProgramDropdown
                    label={properties?.categoryOneLabel}
                    value={selectedCategoryOne}
                    onChange={(e) => setSelectedCategoryOne(e.target.value)}
                    options={categoryOneOptions}
                    defaultLabel={properties?.defaultCategoryLabel}
                />
                <ProgramDropdown
                    label={properties?.categoryTwoLabel}
                    value={selectedCategoryTwo}
                    onChange={(e) => setSelectedCategoryTwo(e.target.value)}
                    options={categoryTwoOptions}
                    defaultLabel={properties?.defaultCategoryLabel}
                />
            </div>
            <ProgramList programs={filteredPrograms} properties={properties} />
        </div>
    );
};

export default ProgramFilter;
